// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".visible {\n    cursor:pointer;\n}\n.labelClass{\n    font-size:14px !important;\n}", ""]);
// Exports
module.exports = exports;
